var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"cmp-third-party-info"},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.xss(_vm.$t('third_party.dialog.info')))}}),_c('ul',_vm._l((_vm.selectedLinks),function(label){return _c('li',{key:label,domProps:{"innerHTML":_vm._s(_vm.xss(_vm.$t(`third_party.dialog.terms.${label}`)))}})}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }